export default __webpack_public_path__ + "static/media/waitlist_bike.b6d92a4f.png";